import router from '@/router/index'
// import {authRouteHandler, generateRoute} from "@/router/authorityRouting";
import store from '@/store'
import { Message } from 'element-ui'
import { dev } from '@/const/env'
import { t } from '@/i18n/index'
router.beforeEach((to, from, next) => {
  const wareType = window.sessionStorage.getItem('wareType')
  console.log('to.path222', to.path, wareType)
  if (/^\/(overseas)(\?.*|\/.*|_.*)?$/.test(to.path) && wareType === '2') {
    if (dev()) {
      location.href = 'http://' + location.hostname + ':8088' + to.fullPath
      return
    }
    axios({
      method: 'GET',
      url: location.origin + to.fullPath,
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/text/html;charset=utf-8'
      }
    }).then((res) => {
      if (res.data.indexOf('OLD_MWS') === -1) {
        // 老项目
        next()
      } else {
        location.href = location.origin + to.fullPath
      }
    })
    return
  }
  if(!/^\/(overseas)(\?.*|\/.*|_.*)?$/.test(to.path) && wareType === '2' && store.getters.getToken) {
    //  如果登录了，链接没有/overseas，则跳转片山仓首页
    if (dev()) {
      location.href = 'http://' + location.hostname + ':8088' + '/overseas/welcome'
      return
    }
    location.href = '/overseas/welcome'
    return
  }
  // console.log(to)
  if (to.path !== '/auth') {
    // 如果不是登录页, 则要去检查是否有 token
    if (!store.getters.getToken) {
      // token 失效去登入
      // console.log(store.getters.getToken)
      Message({
        message: t('登录失效，重新登入！'),
        duration: 800,
        onClose: () => {
          next('/auth')
        }
      })
      // setTimeout(_=> {
      //     next('/auth')
      // }, 1000)
    } /*else if(to.name === '404') {
            // 由于后台管理系统不支持，放弃原本的 动态路由配置，采用本地路由
            // 有token 是404
            // 如果是 404 表明不是基础路由， 去添加
            const isHas = authRouteHandler(to.path)
            // console.log(to.name, isHas)
            if(isHas) {
                // 添加动态路由
                const fullRoutes = generateRoute()
                // console.log(fullRoutes)
                router.addRoute(fullRoutes)
                router.history.setupListeners()
                router.push(to.path)
            } else {
                store.dispatch('menu/restMenu')
                next('/')
            }
        } */ else {
      // 有token 不是404
      // 直接跳转
      next()
    }
  } else {
    // 去登陆
    // 直接跳转
    next()
  }
})

export default router
